export class BankDto {
    id: string;
    bankaAdi: string;
    // firmaAdi: string;
    hesapNo: string;
    iban: string;
    subeKodu: string;
    constructor(
      id: string,
      bankaAdi: string,
      // firmaAdi: string,
      hesapNo: string,
      iban: string,
      subeKodu: string,
    ) {
      this.id = id;
      this.bankaAdi = bankaAdi;
      this.hesapNo = hesapNo;
      // this.firmaAdi = firmaAdi;
      this.iban = iban;
      this.subeKodu = subeKodu;
    }
  }
  